import {useDispatch} from "react-redux";
import useDocumentTitle from "../../hooks/useDocumentTitle";
import React, {useEffect} from "react";
import {resetMenu} from "../../redux/slices/menuSlice";
import {Button, Input, Modal, notification} from "antd";
import axios from "axios";
import EntityApi from "../../api/EntityApi";
import RequestApi from "../../api/RequestApi";
import config from "../../api/config";
import BundledEditor from "../../components/BundledEditor";
import TextArea from "antd/es/input/TextArea";
import TextEditor from "../../components/TextEditor";

const OptionsPage = () => {

    useDocumentTitle('Настройки')
    const dispatch = useDispatch();
    React.useEffect(() => {
        dispatch(resetMenu());
    }, [])
    const editorRef = React.useRef(null);
    const [ editor, setEditor ] = React.useState(null);

    const [saleEmails, setSaleEmails] = React.useState('');
    const [emailFrom, setEmailFrom] = React.useState('');
    /* invoice settings */
    const [company, setCompany] = React.useState('');
    const [companyAddress, setCompanyAddress] = React.useState('');
    const [companyInn, setCompanyInn] = React.useState('');
    const [companyKpp, setCompanyKpp] = React.useState('');
    const [companyAccount, setCompanyAccount] = React.useState('');
    const [companyAccountant, setCompanyAccountant] = React.useState('');
    const [companySupervisor, setCompanySupervisor] = React.useState('');
    const [bank, setBank] = React.useState('');
    const [bankBik, setBankBik] = React.useState('');
    const [bankAccount, setBankAccount] = React.useState('');
    /* contacts */
    const [contactEmail, setContactEmail] = React.useState('');
    const [contactPhone, setContactPhone] = React.useState('');
    /* testing info */
    const [testInformation, setTestInformation] = React.useState('');
    /* user privacy */
    const [isOpenPrivacy, setOpenPrivacy] = React.useState(false);
    const [termOfUser, setTermOfUser] = React.useState('');
    const [termOfUserInitial, setTermOfUserInitial] = React.useState('');
    const [privacyId, setPrivacyId] = React.useState(0);

    const onErrorShow = () => {
        notification.error({
            message: "Ошибка сохранения настроек",
        });
    }

    const onSave = () => {

        let editorTestInformation = '';
        if (editor && editor.current) {
            editorTestInformation = editor.current.getContent();
        }

        RequestApi.post('private/setting', {
            sale_emails: saleEmails,
            email_from: emailFrom,
            company: company,
            companyAddress: companyAddress,
            companyInn: companyInn,
            companyKpp: companyKpp,
            companyAccount: companyAccount,
            companyAccountant: companyAccountant,
            companySupervisor: companySupervisor,
            bank: bank,
            bankBik: bankBik,
            bankAccount: bankAccount,
            contactEmail: contactEmail,
            contactPhone: contactPhone,
            testInformation: editorTestInformation
        }).then(res => {
            if (res.status === RequestApi.STATUS_SUCCESS) {
                notification.success({
                    message: "Настройки успешно сохранены",
                });
                onLoad();
            } else {
                onErrorShow();
            }
        }).catch(err => {
            onErrorShow();
        });
    }

    const onLoad = () => {
        RequestApi.get('private/setting').then(res => {
            if (res.status === RequestApi.STATUS_SUCCESS && res.content.items !== undefined) {
                res.content.items.forEach((item) => {
                    if (item.code === 'sale_emails') {
                        setSaleEmails(item.value);
                    }
                    if (item.code === 'email_from') {
                        setEmailFrom(item.value);
                    }
                    if (item.code === 'company') {
                        setCompany(item.value);
                    }
                    if (item.code === 'companyAddress') {
                        setCompanyAddress(item.value);
                    }
                    if (item.code === 'companyInn') {
                        setCompanyInn(item.value);
                    }
                    if (item.code === 'companyKpp') {
                        setCompanyKpp(item.value);
                    }
                    if (item.code === 'companyAccount') {
                        setCompanyAccount(item.value);
                    }
                    if (item.code === 'companyAccountant') {
                        setCompanyAccountant(item.value);
                    }
                    if (item.code === 'companySupervisor') {
                        setCompanySupervisor(item.value);
                    }
                    if (item.code === 'bank') {
                        setBank(item.value);
                    }
                    if (item.code === 'bankBik') {
                        setBankBik(item.value);
                    }
                    if (item.code === 'bankAccount') {
                        setBankAccount(item.value);
                    }
                    if (item.code === 'contactEmail') {
                        setContactEmail(item.value);
                    }
                    if (item.code === 'contactPhone') {
                        setContactPhone(item.value);
                    }
                    if (item.code === 'testInformation') {
                        setTestInformation(item.value);
                    }
                })
            }
        });
    }

    const onOpenPrivacy = () => {
        setOpenPrivacy(true);
        EntityApi.getBy('content', {
            filter: {slug: 'term_of_use'}
        }).then(res => {
            if (res.status === RequestApi.STATUS_SUCCESS) {
                setTermOfUser(res.content.items[0].text);
                setTermOfUserInitial(res.content.items[0].text);
                setPrivacyId(res.content.items[0].id);
            }
        })
    }

    const onSavePrivacy = () => {
        EntityApi.post('content', privacyId, {
            title: 'Пользовательское соглашение',
            text: termOfUser
        }).then(res => {
            if (res.status === RequestApi.STATUS_SUCCESS) {
                notification.success({
                    message: "Успешно сохранены",
                });
            }
        }).catch(err => {
            notification.error({
                message: "Ошибка сохранения",
            });
        })
    }

    useEffect(() => {
        setEditor(editorRef);
        onLoad();
    }, [])

    return <>
        <div className="flex items-center justify-between py-5 lg:py-6">
            <div className="flex items-center space-x-1">
                <h2 className="line-clamp-1 text-xl font-medium text-slate-700 dark:text-navy-50 lg:text-2xl">
                    Настройки
                </h2>
            </div>
        </div>
        <div className="card px-4 py-4">
            <div className={'flex gap-8'}>
                <div className={'w-6/12'}>
                    <div className={'pb-2 font-bold'}>Контакты:</div>
                    <div className={'pb-2'}>
                        <Input value={contactEmail} onChange={(e) => setContactEmail(e.target.value)}
                               placeholder="Контактны E-mail"/>
                    </div>
                    <div className={'pb-2'}>
                        <Input value={contactPhone} onChange={(e) => setContactPhone(e.target.value)}
                               placeholder="Контактны номер телефона"/>
                    </div>
                    <div className={'pb-2 font-bold'}>E-mail для исходящих писем:</div>
                    <div>
                        <Input value={emailFrom} onChange={(e) => setEmailFrom(e.target.value)}
                               placeholder="Укажите адрес, с которого будут приходить все письма"/>
                    </div>
                    <div className={'pb-2 pt-2 font-bold'}>E-mail для заказов (через запятую):</div>
                    <div>
                        <Input value={saleEmails} onChange={(e) => setSaleEmails(e.target.value)}
                               placeholder="Введите список адресов через запятую"/>
                    </div>
                    <div className={'pb-2 pt-2 font-bold'}>Информация в тестировании (при успешном прохождении):</div>
                    <div>
                        <BundledEditor
                            onInit={(_evt, editor) => editorRef.current = editor}
                            initialValue={testInformation}
                            init={{
                                height: 300,
                                menubar: false,
                                images_upload_url: config.host + '/api/editor/file',
                                plugins: [
                                    'advlist', 'anchor', 'autolink', 'help', 'image', 'link', 'lists',
                                    'searchreplace', 'table', 'wordcount'
                                ],
                                toolbar: 'undo redo | blocks | image ' +
                                    'bold italic forecolor | alignleft aligncenter ' +
                                    'alignright alignjustify | bullist numlist outdent indent | ' +
                                    'removeformat | help',
                                content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                            }}
                        />
                    </div>
                    <div className={'pb-2 pt-2 font-bold'}>Пользовательское соглашение</div>
                    <div>
                        <Button type={'primary'} onClick={() => onOpenPrivacy()}>Изменить</Button>
                    </div>
                    <Modal
                        title={'Пользовательское соглашение'}
                        open={isOpenPrivacy}
                        width={'70%'}
                        onOk={onSavePrivacy}
                        onCancel={() => setOpenPrivacy(false)}
                        cancelText={'Закрыть'}
                        okText={'Сохранить'}
                        maskClosable={true}
                    >
                        <div className={'pt-4'}>
                            <TextEditor height={500} initialValue={termOfUserInitial} onChange={(value) => setTermOfUser(value)} />
                        </div>
                    </Modal>
                </div>
                <div className={'w-6/12'}>
                    <div className={'pb-2 font-bold'}>Настройка оплаты по счету:</div>
                    <div className={'pb-2'}>Название компании:</div>
                    <div>
                        <Input value={company} onChange={(e) => setCompany(e.target.value)}
                               placeholder="Название компании"/>
                    </div>
                    <div className={'pb-2 pt-2'}>Адрес компании:</div>
                    <div>
                        <Input value={companyAddress} onChange={(e) => setCompanyAddress(e.target.value)}
                               placeholder="Адрес компании"/>
                    </div>
                    <div className={'pb-2 pt-2'}>ИНН компании:</div>
                    <div>
                        <Input value={companyInn} onChange={(e) => setCompanyInn(e.target.value)}
                               placeholder="ИНН компании"/>
                    </div>
                    <div className={'pb-2 pt-2'}>КПП компании:</div>
                    <div>
                        <Input value={companyKpp} onChange={(e) => setCompanyKpp(e.target.value)}
                               placeholder="КПП компании"/>
                    </div>
                    <div className={'pb-2 pt-2'}>Бухгалтер компании:</div>
                    <div>
                        <Input value={companyAccountant} onChange={(e) => setCompanyAccountant(e.target.value)}
                               placeholder="Бухгалтер компании"/>
                    </div>
                    <div className={'pb-2 pt-2'}>Руководитель компании:</div>
                    <div>
                        <Input value={companySupervisor} onChange={(e) => setCompanySupervisor(e.target.value)}
                               placeholder="Руководитель компании"/>
                    </div>
                    <div className={'pb-2 pt-2'}>Номер счета:</div>
                    <div>
                        <Input value={companyAccount} onChange={(e) => setCompanyAccount(e.target.value)}
                               placeholder="Номер счета"/>
                    </div>
                    <div className={'pb-2 pt-2'}>Название банк:</div>
                    <div>
                        <Input value={bank} onChange={(e) => setBank(e.target.value)}
                               placeholder="Название банк"/>
                    </div>
                    <div className={'pb-2 pt-2'}>БИК банка:</div>
                    <div>
                        <Input value={bankBik} onChange={(e) => setBankBik(e.target.value)}
                               placeholder="БИК Банка"/>
                    </div>
                    <div className={'pb-2 pt-2'}>Корреспондентский счет банка:</div>
                    <div>
                        <Input value={bankAccount} onChange={(e) => setBankAccount(e.target.value)}
                               placeholder="Корреспондентский счет банка"/>
                    </div>
                </div>
            </div>

            <div className={'pt-4 flex justify-end'}>
                <Button onClick={onSave} type={'primary'}>Сохранить</Button>
            </div>
        </div>
    </>
}

export default OptionsPage
